import styled from 'styled-components';

export const SubscriptionHistoryEmptyBlock = styled.div`
  text-align: center;
  color: #a0a0a7;
  border-top: 1px solid rgba(145, 158, 170, 0.3);
  border-bottom: 1px solid rgba(145, 158, 170, 0.3);
  padding: 30px 0;
`;

export const SubscriptionHistoryLoader = styled.div`
  margin-top: 15px;
`;
